/**
 * Soft pastel palette for chart series (e.g. cycles), in the same tone as
 * the school identity: light, muted and distinct enough to keep several
 * series readable without fighting the brand colors.
 *
 * Use with a modulo/index when there are more series than colors:
 *   CHART_COLORS[index % CHART_COLORS.length]
 */
export const CHART_COLORS = [
  "#b2ecf7", // light cyan
  "#ffc2c2", // light pink
  "#d1e7c0", // light green
  "#d8c7ee", // light violet
  "#ffd97d", // soft amber
  "#ff8b94", // soft coral
  "#ffd9b6", // soft peach
  "#b2c9f7", // soft blue
  "#ffc9ed", // soft magenta
  "#a3e0ce", // soft teal
  "#ffad76", // soft orange
  "#e7b3c8", // soft rose
  "#aedbad", // soft green
  "#90a8e6", // soft periwinkle
  "#e6b890", // soft tan
  "#c2f7d5", // soft mint
  "#d1b2ec", // soft purple
  "#ffd4a2", // soft apricot
  "#a9c0e7", // dusty blue
  "#c7d6f2", // pale blue
  "#ffb6c7", // soft pink
  "#d9f0c2", // pale green
  "#c7b8e6", // soft lavender
  "#ffdf9d", // light amber
  "#b5e3d8", // mint teal
  "#f7c9d5", // rose pink
  "#bcd4f7", // light periwinkle
  "#f2d3b3", // light beige
  "#e3ccf0", // lilac
  "#d9e8a8", // light lime
];
